/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationAccessConnectionsControllerFindAllQueryResponse, IntegrationAccessConnectionsControllerFindAll401, IntegrationAccessConnectionsControllerFindAll403 } from "../../models/integrationAccessController/IntegrationAccessConnectionsControllerFindAll";

function getIntegrationAccessConnectionsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/integration-access-connections` as const }  
  return res
}

/**
 * @summary List the integration projects Document Crunch reads for the caller
 * {@link /api/v1/integration-access-connections}
 */
export async function integrationAccessConnectionsControllerFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationAccessConnectionsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessConnectionsControllerFindAll401 | IntegrationAccessConnectionsControllerFindAll403>, unknown>({ method : "GET", url : getIntegrationAccessConnectionsControllerFindAllUrl().url.toString(), ... requestConfig })  
  return res.data
}